// extracted by mini-css-extract-plugin
export default {"EmailLink":"BottleList_EmailLink__GkfNO"};